import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import applicantService from '../services/applicantService';
import StatusBadge from '../components/common/StatusBadge';
import LoadingSpinner from '../components/common/LoadingSpinner';
import Alert from '../components/common/Alert';
import { statusLabel } from '../utils/applicationStatus';
import { formatDate } from '../utils/formatters';
import './ApplicantPages.css';

// The applicant's own applications, each with a link to the step-by-step page.
const ApplicantPortalPage = () => {
  const [applications, setApplications] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    applicantService
      .myApplications()
      .then(setApplications)
      .catch((err) => setError(err.response?.data?.message || 'Your applications could not be loaded.'));
  }, []);

  if (error) return <Alert type="error" message={error} />;
  if (!applications) return <LoadingSpinner />;

  return (
    <div className="ap-page">
      <h1>My applications</h1>

      {applications.length === 0 ? (
        <div className="ap-card">
          <p>
            You have no applications yet. When a landlord or agent invites you, or you open a property&apos;s
            application link, it will appear here.
          </p>
        </div>
      ) : (
        <ul className="ap-list">
          {applications.map((app) => (
            <li key={app.id} className="ap-card ap-list__item">
              <div>
                <h2 className="ap-list__title">{app.property?.address || `Application ${app.id}`}</h2>
                <p className="ap-muted">Started {formatDate(app.created_at)}</p>
              </div>
              <div className="ap-list__actions">
                <StatusBadge status={app.status} text={statusLabel(app.status)} />
                <Link className="btn-primary ap-button" to={`/applicant/application/${app.id}`}>Open</Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ApplicantPortalPage;
